import React from 'react';
import { Box } from '@mui/material';
import BusinessCaseTable from '../../../shared/BusinessCaseTable';
import BusinessProcessUseCaseTable from '../../../shared/BusinessProcessUseCaseTable';

const WizardStepUseCase = ({
  values,
  errors,
  onSetField,
  lookups,
  onRefreshLookups,
  softwareId = null,
  softwareName = '',
  onBeforeView,
  documents = [],
  onDocumentsChange,
}) => (
  <Box display="flex" flexDirection="column" gap={2.5} pt={0.5}>
    <BusinessCaseTable
      businessCase={values.businessCase || null}
      onChange={(next) => onSetField('businessCase', next)}
      error={errors?.businessCase}
      softwareId={softwareId}
      softwareName={softwareName}
      onBeforeView={onBeforeView}
      documents={documents}
      onDocumentsChange={onDocumentsChange}
    />

    <BusinessProcessUseCaseTable
      rows={values.businessProcesses || []}
      onChange={(next) => onSetField('businessProcesses', next)}
      processOptions={lookups?.businessProcesses || []}
      onRefreshLookups={onRefreshLookups}
      error={errors?.businessProcesses}
    />
  </Box>
);

export default WizardStepUseCase;
